import React, {useEffect, useState} from "react";
import {withI18n} from "@lingui/react";
import {getLocaleFromPath} from "utils/i18n.js";
import Layout from "components/layout/layout";
import LiveVideo from "../../components/LiveVideo";
import Videos from "../../components/Videos";
import {graphql, useStaticQuery} from "gatsby";

const IndexPage = ({location, data}) => {

    const query = useStaticQuery(graphql`
        query {
          site {
            siteMetadata {
              videoRest {
                endpoints {
                  popularVideos
                  newVideos
                  liveList
                }
              }
            }
          }
        }
    `);

    var newVideosUrl = query.site.siteMetadata.videoRest.endpoints.newVideos;
    var popularVideosUrl = query.site.siteMetadata.videoRest.endpoints.popularVideos;
    var liveVideosUrl = query.site.siteMetadata.videoRest.endpoints.liveList;

    const [loadedData, setLoadedData] = useState(null);
    useEffect(() => {
        Promise.all([
            fetch(newVideosUrl).then(response => response.json()).catch(error => {
                console.log(error);
                return [];
            }),
            fetch(popularVideosUrl).then(response => response.json()).catch(error => {
                console.log(error);
                return [];
            }),
            fetch(liveVideosUrl).then(response => response.json()).catch(error => {
                console.log(error);
                return [];
            })
        ]).then(result => {
            setLoadedData(
                {
                    newVideos: result[0],
                    popularVideos: result[1],
                    liveVideos: result[2]
                });
        });
    }, [newVideosUrl, popularVideosUrl, liveVideosUrl]);

    const locale =  getLocaleFromPath(location.pathname);

    return (!loadedData ? '' : (
        <Layout location={location}>
            <div className="MainContent">
                <LiveVideo video={loadedData.liveVideos[0]}/>
                <Videos title="Nové videá" locale={locale} items={loadedData.newVideos.slice(0, 4)}/>
                <Videos title="Populárne videá" locale={locale} items={loadedData.popularVideos.slice(0, 4)}/>
            </div>
        </Layout>
    ));
};

export default withI18n()(IndexPage);

